import React, { useState } from "react";
import { validateUsername, validateEmail } from "../services/Validation";
import { resendVerificationEmail } from "../services/Api";
import { useTranslation } from "react-i18next";
import "../css/Profile.css";

const ProfileForm = ({ profileData, handleChange, handleSubmit, errors, setErrors }) => {
  const { t } = useTranslation();
  const [emailButtonText, setEmailButtonText] = useState(
    !profileData.isVerified ? t("profile.profile.emailNotVerified") : ""
  );
  const [isEmailButtonDisabled, setIsEmailButtonDisabled] = useState(false);

  // Validation locale du formulaire
  const validateProfile = () => {
    const newErrors = {};

    const firstNameValidation = validateUsername(profileData.firstName);
    if (!firstNameValidation.valid) newErrors.firstName = firstNameValidation.error;

    const lastNameValidation = validateUsername(profileData.lastName);
    if (!lastNameValidation.valid) newErrors.lastName = lastNameValidation.error;

    const emailValidation = validateEmail(profileData.email);
    if (!emailValidation.valid) newErrors.email = emailValidation.error;

    if (!profileData.dateOfBirth) newErrors.dateOfBirth = "La date de naissance est requise.";
    if (!profileData.countryOfResidency) newErrors.countryOfResidency = "Le pays de résidence est requis.";
    
    return newErrors;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateProfile();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    handleSubmit(profileData); // Appelle la fonction du parent
  };

  const sendVerificationEmail = async () => {
    setEmailButtonText(t("profile.profile.emailVerify"));
    setIsEmailButtonDisabled(true);
    try {
      await resendVerificationEmail(profileData.email);
    } catch (err) {
      console.error(err);
      setEmailButtonText(t("profile.profile.emailNotVerified"));
      setIsEmailButtonDisabled(false);
    }
  }

  return (
    <form onSubmit={onSubmit} className="profile-form">
      <h2>{t("profile.profile.title", "Informations personnelles")}</h2>
      <div className="username-display">
        <div className="profil-username">{profileData.username || "—"}</div>
      </div>
      <div className="form-grid">
         {[
            { name: "lastName", label: t("profile.profile.lastname"), type: "text" },
            { name: "firstName", label: t("profile.profile.firstname"), type: "text" },               
            { name: "email", label: t("profile.profile.email"), type: "text" },
            // { name: "dateOfBirth", label: t("profile.profile.dob"), type: "date" },            
            // { name: "countryOfResidency", label: t("profile.profile.country"), type: "text" },
            { name: "gender", label: t("profile.profile.gender.value"), type: "select", 
              options: [
                { value: "", label: t("profile.profile.gender.select") },
                { value: "male", label: t("profile.profile.gender.male") },
                { value: "female", label: t("profile.profile.gender.female") },
              ] 
            },
            // { name: "passion", label: t("profile.profile.passion"), type: "text" },
            // { name: "mission", label: t("profile.profile.mission"), type: "text" },
            // { name: "vocation", label: t("profile.profile.vocation"), type: "text" },
            // { name: "profession", label: t("profile.profile.profession"), type: "text" },
            // { name: "birthTime", label: t("profile.profile.dobTime"), type: "time" },
            // { name: "birthPlace", label: t("profile.profile.dobPlace"), type: "text" },
          ].map(({ name, label, type, options }) => (
          <div className="form-group" key={name}>
            <label>
              {label} :
              {name === "email" && !profileData.isVerified && profileData.email && (
                <button
                  type="button"
                  className="verify-email-button"
                  onClick={sendVerificationEmail}
                  disabled={isEmailButtonDisabled}
                >
                  {emailButtonText}
                </button>
              )}
            </label>
              {type === "select" ? (
                <select name={name} value={profileData[name] || ""} onChange={handleChange}>
                  {options.map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={type}
                  name={name}
                  value={profileData[name] || ""}
                  onChange={handleChange}
                />
              )}
            {errors[name] && <span className="error">{errors[name]}</span>}
          </div>
        ))}
      </div>

      <div className="submit-form">
        <button type="submit">{t("profile.profile.save")}</button>
      </div>
    </form>
  );
};

export default ProfileForm;
